<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 mx-auto overflow-y-auto shadow"
  [ngClass]="
    (isMobile$ | async)
      ? 'bottom-0 max-h-85-screen max-w-screen-sm'
      : 'flex justify-center items-center w-full h-full top-0 left-0'
  "
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="p-5 overflow-y-auto bg-white max-h-85-screen"
    [ngClass]="(isMobile$ | async) ? 'rounded-t-3xl' : 'rounded-3xl min-w-448'"
    [class.pb-8]="isNotched"
    [style.z-index]="(index$ | async) + 50"
  >
    <header class="flex justify-between w-full">
      <h1
        class="pb-5 font-bold text-neutral-800 font-brand text-28px"
        translate="delivery-addresses-modal.title"
      ></h1>
      <a
        class="block p-2 cursor-pointer"
        (click)="close()"
        ><i class="icon icon-cross"></i
      ></a>
    </header>
    <div
      *ngIf="!isForm"
      class="px-1.5 mb-4"
    >
      <a
        class="flex items-center block text-sm font-bold cursor-pointer text-primary-600"
        (click)="addNewAddress()"
        ><i class="mr-3 icon icon-plus"></i>
        {{ 'delivery-addresses-modal.add-addresse' | translate }}</a
      >
      <ng-container *ngIf="!(loadingDeliveryAddresses$ | async)">
        <div
          *ngIf="savedDeliveryAddresses$ | async as addresses"
          class="pt-6 op"
        >
          <ul>
            <li
              *ngFor="let address of addresses"
              class="flex justify-between mb-4"
              [class.opacity-20]="address.id === addressBeingDeleted"
            >
              <div class="flex items-center">
                <div class="flex items-center p-2 pl-0 pr-4">
                  <i class="icon icon-pin text-29px text-neutral-800"></i>
                </div>
                <div class="text-sm">
                  <p
                    *ngIf="address?.name"
                    class="font-bold"
                  >
                    {{ address.name }}
                  </p>
                  <p *ngIf="address?.street">
                    {{ address.street }}
                  </p>
                  <p>
                    <span *ngIf="address.postal_code">{{ address.postal_code }} </span
                    ><span *ngIf="address.city">{{ address.city }}</span>
                  </p>
                  @if (address?.instructions) {
                    <p class="italic text-neutral-600">{{ address.instructions }}</p>
                  }
                  <a
                    class="block font-bold cursor-pointer text-primary-800"
                    (click)="deleteExistingAddress(address.id)"
                    >{{ 'delivery-addresses-modal.delete' | translate }}</a
                  >
                </div>
              </div>
              <app-button-atom
                size="S"
                [disabled]="address.id === addressBeingDeleted"
                [label]="'delivery-addresses-modal.button' | translate"
                [color]="'primary'"
                [type]="'light'"
                [thickSize]="'XS'"
                (click)="chooseExistingAddress(address)"
              ></app-button-atom>
            </li>
          </ul>
        </div>
      </ng-container>
      <div *ngIf="loadingDeliveryAddresses$ | async">
        <ng-container *ngFor="let i of [].constructor(3)">
          <div class="flex mt-2">
            <div class="p-2">
              <i class="icon icon-pin"></i>
            </div>
            <div class="w-full">
              <p class="w-6/12 animate-pulse mb-1.5 py-1.5 bg-neutral-100"></p>
              <p class="w-4/12 animate-pulse mb-1.5 py-1.5 bg-neutral-100"></p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="isForm">
      <div class="mb-5">
        <app-input-text-atom
          [label]="'parameters.location-placeholder' | translate"
          [iconRight]="'icon-position'"
          [value]="displayedValue"
          [cross]="true"
          (iconClick)="geolocalizeUser()"
          (valueChange)="valueChanged($event)"
        ></app-input-text-atom>
      </div>
      <div class="mb-5">
        <app-button-atom
          type="light"
          size="S"
          thickSize="S"
          full="true"
          icon="icon-position"
          [label]="'parameters.geolocalize-button' | translate"
          (clickEventEmitter)="geolocalizeUser()"
        ></app-button-atom>
      </div>
      <div
        *ngIf="deliveryAddressError"
        class="px-4 py-3 my-5 text-sm rounded text-error-700 font-base bg-error-50"
      >
        {{ deliveryAddressError }}
      </div>
      <div>
        <label
          for="name"
          class="block mb-1 -mt-1 text-sm font-normal leading-5 font-base text-neutral-500"
          >{{ 'delivery-addresses-modal.name-input' | translate }}</label
        >
        <input
          id="name"
          type="text"
          [ngModel]="addressName"
          (ngModelChange)="onInputNameChange($event)"
          class="flex w-full px-5 py-3 mb-6 text-base font-normal leading-5 border border-solid bg-neutral-50 font-base border-neutral-300"
        />
      </div>
      <div>
        <app-parameters-delivery-instructions-block
          [instructions]="instructions"
          (instructionsChanged)="instructions = $event"
        ></app-parameters-delivery-instructions-block>
      </div>
      <div class="flex-1 pt-6">
        <app-button-atom
          *ngIf="!saveAddressLoading"
          [type]="'primary'"
          [size]="'L'"
          [label]="'delivery-addresses-modal.button' | translate"
          [disabled]="!displayedValue"
          (click)="selectAddress()"
        >
        </app-button-atom>
        <app-button-atom
          *ngIf="saveAddressLoading"
          [type]="'primary'"
          [size]="'L'"
          [disabled]="!displayedValue"
          [label]="'delivery-addresses-modal.button' | translate"
          [iconUrl]="saveAddressLoading ? 'assets/images/spinner.svg' : undefined"
          (click)="selectAddress()"
        >
        </app-button-atom>
      </div>
    </div>
  </div>
</div>
